import { Marker, Polygon, Polyline } from "@react-google-maps/api";

type LatLngPoint = { lat: number; lng: number };

type DraftZonePathProps = {
    path: LatLngPoint[];
    onMovePoint: (index: number, point: LatLngPoint) => void;
    onClose: () => void;
};

export default function DraftZonePath({ path, onMovePoint, onClose }: DraftZonePathProps) {
    if (path.length === 0 || !window.google?.maps) {
        return null;
    }

    const dot = {
        path: window.google.maps.SymbolPath.CIRCLE,
        scale: 7,
        fillColor: "#ff0000",
        fillOpacity: 1,
        strokeColor: "#ffffff",
        strokeWeight: 2,
    };

    return (
        <>
            {path.length >= 2 && (
                <Polyline
                    path={path}
                    options={{
                        strokeColor: "#ff0000",
                        strokeOpacity: 1,
                        strokeWeight: 2,
                        clickable: false,
                    }}
                />
            )}
            {path.length >= 3 && (
                <Polygon
                    paths={path}
                    options={{
                        fillColor: "#ff0000",
                        fillOpacity: 0.2,
                        strokeOpacity: 0,
                        clickable: false,
                        editable: false,
                        draggable: false,
                    }}
                />
            )}
            {path.map((point, index) => (
                <Marker
                    key={index}
                    position={point}
                    draggable
                    icon={index === 0 && path.length >= 3 ? { ...dot, scale: 9 } : dot}
                    title={index === 0 && path.length >= 3 ? "Click to close the zone, or drag to move this corner" : "Drag to move this corner"}
                    onClick={() => {
                        if (index === 0 && path.length >= 3) {
                            onClose();
                        }
                    }}
                    onDragEnd={(event) => {
                        if (!event.latLng) {
                            return;
                        }
                        onMovePoint(index, { lat: event.latLng.lat(), lng: event.latLng.lng() });
                    }}
                />
            ))}
        </>
    );
}
